import React from 'react';
import Profile from 'modules/Profile/components/Profile';

const ProfilePage: React.FC = (): JSX.Element => {
  return <Profile />;
};

export default ProfilePage;
